// Import package components
import { useContext } from "react";
import UIkit from "uikit";

// Import base components
import { AppContexts } from "../../../providers";

// Import common components
import Dialog from "../../common/Dialog";

const RecommendationDelete = () => {
  const { deleteRecommendation, deletedRecommendation } = useContext(
    AppContexts.DestinationContext,
  );

  const handleDelete = async () => {
    const response = await deleteRecommendation(
      deletedRecommendation.recommendation_id,
      deletedRecommendation.destination_id,
    );
    if (!response?.error) {
      UIkit.modal("#recommendation-delete").hide();
    }
  };

  return (
    <>
      <Dialog id="recommendation-delete">
        <div className="uk-modal-dialog uk-modal-body">
          <button
            className="uk-modal-close-default"
            type="button"
            uk-close="true"
          ></button>
          <h2 className="uk-modal-title">Delete Recommendation</h2>
          <p>
            Are you sure you want to delete{" "}
            <b>{deletedRecommendation?.name || ""}</b>?
          </p>
          <p className="uk-text-right">
            <button
              className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
              type="button"
            >
              Cancel
            </button>
            <button
              className="uk-button hms-btn hms-gray-btn"
              type="button"
              onClick={handleDelete}
            >
              Delete
            </button>
          </p>
        </div>
      </Dialog>
    </>
  );
};

export default RecommendationDelete;
